module.exports = [
{"pathName":"/","layout":4,"navconfig":{"isHome":true,"title":"发布商品","fixedConfig":{"isFixed":true}}},
{"pathName":"/result","layout":0}
]